// import Link from 'next/link'
import Link from 'next/link'
import Layout from '../components/Layout'


const ThankYouPage = () => {
    return (
    <Layout title="Thank You">
      <div className="home landing-v1 relative flex-col-reverse md:flex-row min-h-screen">
        <div className="px-4 w-full">
          <nav className="p-4 xl:container m-auto ">
            <Link href="/">
              <img src="/images/solar-quote-logo.png" alt="" width="245" className="w-40 xxs:w-60" />
            </Link>{' '}
          </nav>
        </div>
        <div className=" xl:container m-auto">
          <div className="w-full m-auto text-center md:w-3/5 xl:w-1/2 2xl:w-2/5 thnakyou p-4 sm:p-8 flex flex-col justify-center items-center">
            {/* <div className="w-full flex flex-col md:flex-row items-center justify-between"> */}
              {/* <div className="w-full lg:w-1/2"> */}
                <h2 className=" main__heading  text-3xl xxs:text-5xl xl:text-6xl font-primaryBold text-white capitalize">
                  Thank You For <span className="block">Your Submission!</span>
                </h2>
                <p className="mt-3 text-base sm:mt-5 sm:text-lg  md:mt-5 md:text-xl lg:mx-0 text-white">
                  One of our qualified representatives will be reaching out shortly to discuss your home improvement project.
                </p>
                <Link href="/" >
                  <span className="mt-8 text-base text-white flex flex-row items-center cursor-pointer"> <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>Back to Home</span>
                  
            </Link>{' '}
              {/* </div> */}


            {/* </div> */}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ThankYouPage